var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"action-bar",class:{ 'action-bar--ml': !_vm.hasMainMenuOpen },attrs:{"data-js":"get-height","flat":""}},[_c('Breadcrumb',{attrs:{"routes":_vm.breadcrumbItems}}),_c('v-spacer'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }